import React from 'react'
import image from '../../assets/images/main.jpg'

export default function MainBanner() {
  return (
    <div>
       <img src={image} alt="main banner" className='main--banner--img'/> 
    </div>
  )
}
